import * as React from 'react';
import 'rc-time-picker/assets/index.css';
import { FieldProps, ErrorMessage } from 'formik';
// @ts-ignore
import TimePicker from 'rc-time-picker';
import { Box } from '../';
import { Span, Label } from '../../typography';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import styled from 'styled-components';
import { themeGet } from 'styled-system';
import { Moment } from 'moment';

type Props = StyledSystemProps &
  FieldProps &
  WrapperProps & {
    name: string;
    label?: string;
    color?: string;
    bg?: string;
    disabled?: boolean;
    initialDate?: Moment;
    placeholder?: string;
  };

type WrapperProps = {
  isSmall?: boolean;
};

const TimePickerWrapper = styled.div<WrapperProps>`
  .TimePicker {
    width: 100%;
  }
  .rc-time-picker-input {
    height: ${props => (props.isSmall ? '30px' : '40px')};
    width: 100%;
    background-color: ${themeGet('colors.paleGrey', '#f0f1f3')};
    border: 1px solid rgba(50, 50, 93, 0.2);
    color: ${themeGet('colors.coal', '#222429')};
    font-size: ${themeGet('fontSize[1]', '16px')};
  }
  .rc-time-picker-input:disabled {
    color: #ccc !important;
    background: #f7f7f7 !important;
    cursor: not-allowed !important;
  }
`;

const StyledTimePicker: React.FC<Props> = ({
  placeholder,
  name,
  label,
  field,
  disabled,
  form,
  initialDate,
  isSmall,
  ...rest
}) => {
  const popUpStyle = {
    paddingTop: isSmall ? '35px' : '45px',
  };
  return (
    <Box {...rest}>
      {label && <Label htmlFor={name}>{label}</Label>}
      <TimePickerWrapper isSmall={isSmall}>
        {/* ts-ignore is used here as "autoComplete" exists in docs, but not in node_module imported for TimePicker
          // @ts-ignore */}
        <TimePicker
          placeholder={placeholder || 'Select time'}
          inputReadOnly={true}
          id={name}
          allowEmpty={false}
          showSecond={false}
          disabled={disabled}
          className="TimePicker"
          onChange={(time: any) => form.setFieldValue(name, time)}
          autoComplete="off"
          minuteStep={5}
          value={field.value}
          popupClassName="TimePickerPopUp"
          popupStyle={popUpStyle}
          isSmall={isSmall}
        />
      </TimePickerWrapper>
      <ErrorMessage name={name}>
        {msg => {
          return (
            <Span mt={2} color="error" textAlign="right">
              {msg}
            </Span>
          );
        }}
      </ErrorMessage>
    </Box>
  );
};

export default StyledTimePicker;

StyledTimePicker.defaultProps = {
  mb: 4,
  flex: 1,
  minWidth: '150px',
};



// WEBPACK FOOTER //
// ./src/components/formElements/StyledTimePicker.tsx